import { useRef, useEffect, useState } from "react";
import { classUrl } from "../../../Configs";
import { useTranslation } from "react-i18next";
import { useUserApi, useLoginPlaymove } from "../../../Hooks";

// Imagens e ícones
import header from "../../../assets/img/cabecalho-login.png";
import footer from "../../../assets/img/footer-login.png";
import classIcon from "../../../assets/img/logo-class.png";
import academiaIcon from "../../../assets/img/logo-academia.png";
import analyticsIcon from "../../../assets/img/logo-playmove-analytics.png";
import learningIcon from "../../../assets/img/logo-playmove-learning.png";
import LanguageSelector from "../../Shared/LanguageSelector";
import { getInitialLanguage } from "../../../Utils/getInitialLanguage";

export default function AcessoPlataformas() {
  const userApi = useUserApi();
  const { tokenExists, logout } = useLoginPlaymove();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(getInitialLanguage());
  const hasUpdatedLanguage = useRef(false);
  const updateUserLanguageRef = useRef(userApi.updateUserLanguage);

  useEffect(() => {
    updateUserLanguageRef.current = userApi.updateUserLanguage;
  }, [userApi]);

  useEffect(() => {
    if (!tokenExists()) {
      localStorage.setItem('loginUnique', true);
      logout();
    }
  }, [tokenExists, logout]);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const token = localStorage.getItem("tokenClass");
    if (hasUpdatedLanguage.current || !email || !token) {
      return;
    }

    hasUpdatedLanguage.current = true;
    updateUserLanguageRef.current?.(email, token, language)
      .catch((err) => console.error("Erro ao atualizar idioma no banco:", err));
  }, [language]);
  // Parâmetros da query string
  const email = localStorage.getItem("email") || "";
  const tokenClass = localStorage.getItem("tokenClass") || ""

  // URLs de exemplo
  const ACADEMIA_URL = "/home";
  const CLASS_URL = `${classUrl}/loginByToken`;

  const classParams = new URLSearchParams({
    login: email,
    token: tokenClass,
    lang: language.toLowerCase()
  }).toString();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* HEADER */}
      <div className="w-full">
        <img
          src={header}
          alt={t("headerAlt")}
          className="w-full h-auto object-cover"
        />
      </div>

      {/* ÁREA PRINCIPAL */}
      <div className="flex-grow flex flex-col items-center justify-center px-4">
        <div className="mt-8 md:mt-12 w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* Card Playmove Academia */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-xl p-6 flex flex-col items-center text-center">
            <img
              src={language == 'pt-BR' ? academiaIcon : learningIcon}
              alt={t("academiaAlt")}
              className="h-[9rem] w-[10rem] mb-4"
            />
            <b className="text-lg text-gray-600 mt-2 max-w-xs">
              {t("academiaCardDescription")}
            </b>
            <a
              href={`${ACADEMIA_URL}`}
              data-testid="access-learning"
              className="w-full mt-6 bg-blue-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors"
            >
              {t("accessButton")}
            </a>
          </div>

          {/* Card Playmove Class */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-xl p-6 flex flex-col items-center text-center">
            <img
              src={language == 'pt-BR' ? classIcon : analyticsIcon}
              alt={t("classAlt")}
              className="h-[9rem] mb-4"
            />
            <b className="text-lg text-gray-600 mt-2 max-w-xs">
              {t("classCardDescription")}
            </b>
            <a
              href={`${CLASS_URL}?${classParams}`}
              data-testid="access-analytics"
              className="w-full mt-6 bg-yellow-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-yellow-600 transition-colors"
            >
              {t("accessButton")}
            </a>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="py-4 flex justify-center items-center">
        <img src={footer} alt={t("footerAlt")} />
      </div>

      {/* Seletor de Idioma (canto inferior direito) */}
      <LanguageSelector onLanguageChange={(lang) => setLanguage(lang)} />
    </div>
  );
}
